import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CottageIcon from '@mui/icons-material/Cottage';
import LocalCarWashIcon from '@mui/icons-material/LocalCarWash';
import WorkIcon from '@mui/icons-material/Work';
import WashIcon from '@mui/icons-material/Wash';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Blacha1 from '../resources/blacha.jpeg'
import Kominek1 from '../resources/kominek.jpeg'
import Meble1 from '../resources/meble.jpeg'
import Okno1 from '../resources/okno.jpeg'
import Samochod1 from '../resources/samochod.jpeg'

import Etykieta from '../resources/etykieta.jpeg'
import img_biuro1 from '../resources/img_biuro1.png'
import img_samochod1 from '../resources/img_samochod1.png'
import img_dom1 from '../resources/img_dom1.png'
import img_remont1 from '../resources/img_remont1.png'


const items = [
  {
    icon: <CottageIcon />,
    title: 'Sprzątanie domów i mieszkań',
    description:
      'Regularne sprzątanie, pranie i prasowanie, czyszczenie dywanów i tapicerki.',
    image: img_dom1,
  },
  {
    icon: <LocalCarWashIcon />,
    title: 'Sprzątanie samochodów',
    description:
      'Mycie i woskowanie karoserii, czyszczenie wnętrza, pranie tapicerki, odkurzanie, czyszczenie szyb.',
      image: img_samochod1,
  },
  {
    icon: <WorkIcon />,
    title: 'Sprzątanie biur',
    description:
      'Regularne sprzątanie biur, dezynfekcja powierzchni, opróżnianie koszy na śmieci, mycie okien.',
      image: img_biuro1,
  },
  {
    icon: <WashIcon />,
    title: 'Sprzątanie po remontach',
    description:
      'Usuwanie pyłu budowlanego, czyszczenie pozostałości po farbach i klejach, mycie podłóg i ścian.',
      image: img_remont1,
  },
  {
    icon: <SupportAgentIcon />,
    title: 'Usługi dodatkowe',
    description:
      'Do uzgodnienia, w trakcie rozmowy telefonicznej lub za pomocą e-maila.',
    image: Etykieta
  },
];

export default function Services() {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index: number) => {
    setSelectedItemIndex(index);
  };

  const selectedFeature = items[selectedItemIndex];

  return (
    <Container id="services" sx={{ py: { xs: 8, sm: 16 } }}>
      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <div>
            <Typography component="h2" variant="h4" color="text.primary">
              Usługi
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: { xs: 2, sm: 4 } }}
            >
              Oferujemy szeroki zakres usług sprzątających dostosowanych do Twoich potrzeb!
            </Typography>
          </div>
          <Grid container item gap={1} sx={{ display: { xs: 'flex', sm: 'none' } }}>
            {items.map(({ title }, index) => (
              <Chip
                key={index}
                label={title}
                onClick={() => handleItemClick(index)}
                sx={{
                  borderColor: (theme) => (selectedItemIndex === index ? 'primary.light' : ''),
                  backgroundColor: selectedItemIndex === index ? 'primary.main' : '',
                  '& .MuiChip-label': {
                    color: selectedItemIndex === index ? '#fff' : '',
                  },
                }}
              />
            ))}
          </Grid>
          <Box
            component={Card}
            variant="outlined"
            sx={{
              display: { xs: 'flex', sm: 'none' },
              mt: 4,
            }}
          >
            <Box sx={{ px: 2, pb: 2, pt: 2 }}>
              <Typography color="text.primary" variant="body2" fontWeight="bold">
                {selectedFeature.title}
              </Typography>
              <Typography color="text.secondary" variant="body2" sx={{ my: 0.5 }}>
                {selectedFeature.description}
              </Typography>
            </Box>
          </Box>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
            useFlexGap
            sx={{ width: '100%', display: { xs: 'none', sm: 'flex' } }}
          >
            {items.map(({ icon, title, description }, index) => (
              <Card
                key={index}
                variant="outlined"
                component={Button}
                onClick={() => handleItemClick(index)}
                sx={{
                  p: 2,
                  height: 'fit-content',
                  width: '100%',
                  backgroundColor:
                    selectedItemIndex === index ? 'action.selected' : undefined,
                  borderColor: (theme) => (selectedItemIndex === index ? 'primary.light' : 'grey.200'),
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    textAlign: 'left',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { md: 'center' },
                    gap: 2.5,
                  }}
                >
                  <Box
                    sx={{
                      color: (theme) => (selectedItemIndex === index ? 'primary.main' : 'grey.300'),
                    }}
                  >
                    {icon}
                  </Box>
                  <Box sx={{ textTransform: 'none' }}>
                    <Typography
                      color="text.primary"
                      variant="body2"
                      fontWeight="bold"
                    >
                      {title}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      sx={{ my: 0.5 }}
                    >
                      {description}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            ))}
          </Stack>
        </Grid>

        {/* Original Grid item for larger screens */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: { xs: 'none', sm: 'flex' }, width: '100%' }}
        >
          <Card
            variant="outlined"
            sx={{
              height: '100%',
              width: '100%',
              display: { xs: 'none', sm: 'flex' },
            }}
          >
            <img
              src={items[selectedItemIndex].image}
              alt="Item"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
              }}
            />
          </Card>
        </Grid>

        {/* New Grid item for mobile devices */}
        <Grid
          item
          xs={12}
          sx={{ display: { xs: 'flex', sm: 'none' }, width: '100%' }}
        >
          <Card
            variant="outlined"
            sx={{
              height: '100%',
              width: '100%',
              display: { xs: 'flex', sm: 'none' },
            }}
          >
            <img
              src={items[selectedItemIndex].image}
              alt="Item"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'fill',
              }}
            />
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
